import { dataLayer, JSONFetcher, report, postValues } from 'shared'

export const submitHandler = async (values, formikBag) => {
  dataLayer.push({
    event: 'eeCheckout',
    ecommerce: { currencyCode: 'EUR', checkout: { actionField: { step: 2, option: values.payment_method } } }
  })

  const response = await JSONFetcher.call({ url: values._submit_url, method: 'POST', body: postValues(values) })
    .catch(e => { // any server side error (500, 502, ...)
      report(e)
      return ({ errors: { base: 'unknown_error' } })
    })

  const { paypal_token, stripe_payment_intent_client_secret, redirect_to, errors } = response

  if (errors && Object.keys(errors).length > 0) {
    let errorMsgs = {}
    Object.keys(errors).map(k => errorMsgs[k] = I18n.t(`donate.errors.${errors[k]}`))
    errorHandler(errorMsgs, formikBag)
  }
  else if (paypal_token) {
    paypalFinalize(formikBag, paypal_token, redirect_to)
  }
  else if (values.payment_method === 'stripe_sepa_debit') {
    if (throttle()) return errorHandler({ stripe_token: I18n.t('donate.errors.throttled') }, formikBag)
    await stripeSEPADebitFinalize(formikBag, values, stripe_payment_intent_client_secret, redirect_to)
  }
  else if (values.payment_method === 'stripe_cc') {
    if (throttle()) return errorHandler({ stripe_token: I18n.t('donate.errors.throttled') }, formikBag)
    await stripeCCFinalize(formikBag, values, stripe_payment_intent_client_secret, redirect_to)
  }
  else if (redirect_to) {
    redirect({ to: redirect_to, formikBag })
  }
}

const paypalFinalize = (formikBag, paypalToken, redirectTo) => {
  formikBag.setFieldValue('_paypal_token', paypalToken)
  formikBag.setFieldValue('_redirect_to', redirectTo)
  // setting isSubmitting to false lets the PaypalButton know that it can enter the auth flow
  formikBag.setSubmitting(false)
}

let lastCallTime = 0

const throttle = () => {
  const currentCallTime = (new Date()).getTime()
  const calledRecently = currentCallTime - lastCallTime < 2
  lastCallTime = currentCallTime
  return calledRecently
}

const stripeCCFinalize = async (formikBag, values, paymentIntentClientSecret, redirectTo) => {
  const args = {
    payment_method: {
      card: values._stripe_get_element('card'),
      billing_details: {
        name: `${values.first_name} ${values.last_name}`,
      }
    }
  }

  const result = await values._stripe.confirmCardPayment(paymentIntentClientSecret, args)
  const error = result.error

  if (error && !/already succeeded/.test(error.message)) {
    const msg = I18n.t(`donate.errors.stripe_cc_${error.code}`, { defaultValue: error.message })
    errorHandler({ stripe_token: msg }, formikBag)
  } else {
    redirect({ to: redirectTo, formikBag })
  }
}

const stripeSEPADebitFinalize = async (formikBag, values, paymentIntentClientSecret, redirectTo) => {
  const args = {
    payment_method: {
      sepa_debit: values._stripe_get_element('iban'),
      billing_details: {
        name: `${values.first_name} ${values.last_name}`,
        email: values.email,
      }
    }
  }

  // make sure that a given company_name appears in the sepa mandate that is generated by Stripe
  if (values._company_donation && values.company_name) {
    args.payment_method.billing_details.address = {
      city: values.city,
      line1: values.company_name,
      postal_code: values.zip,
    }
  }

  const result = await values._stripe.confirmSepaDebitPayment(paymentIntentClientSecret, args)
  const error = result.error

  if (error && !/already succeeded/.test(error.message)) {
    const msg = I18n.t(`donate.errors.stripe_sepa_debit_${error.code}`, { defaultValue: error.message })
    errorHandler({ stripe_token: msg }, formikBag)
  } else {
    redirect({ to: redirectTo, formikBag })
  }
}

const errorHandler = (errors, formikBag) => {
  formikBag.setFieldValue('_step', 1, false)
  formikBag.setErrors(errors)
  formikBag.setSubmitting(false)
}

const redirect = ({ to, formikBag }) => {
  // stay non-interactable while redirect is in progress
  // to prevent confusion and extraneous submits
  formikBag.setFieldValue('_redirecting', true)
  setTimeout(() => window.location = to, 10)
}
